module.exports = __webpack_public_path__ + "static/media/logo-polymer.7d0fc352.svg";